/**
 * This is the generic config object that is used throughout the system.
 * This object is a Singleton.
 * During initialization of the env properties of this configuration can be manipulated individually
 *
 *
 * The setConfig method is where you can enter the main configuration settings for your interactive map. This method accepts a JavaScript object literal. The following is the default configuration and shows all of the options that you can change via the setConfig method.
 *
 * this is the default configuration:
 * ```javascript
 * {
 *   // this is the default configuration for the availability
 *   availability: {
 *     url:     null, // url of the availabilty parser xml
 *     parser:  null, // link to the parser
 *     refresh: 60000 // 1 minute - refresh rate of the availability
 *   },
 *
 *   // this is the default configuration for the availability
 *   geometry: {
 *     url:    null, // url of the geometry parser xml
 *     bg:     null, // background image used for the map (currently an swf for microflex maps)
 *     parser: null // link to the parser
 *   },
 *
 *   minimap: {
 *     show: false,
 *     showAtScaleGreaterThan: 1
 *   },
 *
 *   system: {
 *     showSeats:        true,
 *     showAllSeats:     false, //shows all of the seats at the same time
 *     scrollToZoom:     false,  //boolean to determine whether you can zoom the map by scrolling
 *     hideNavigation:   false, //hides the zoomer (zoom in, zoom out) buttons on the map
 *     avoidSingleSeats: true
 *   },
 *
 *   tooltip: {
 *     views:  null, //object that initializes the tooltip using the SIM.React property
 *     parser: null  //function that returns the data that is rendered in the tooltip
 *   }
 * }
 ```
 */
export default {

  // this is the default configuration for the availability
  availability: {
    url:     null,
    parser:  null,
    refresh: 60000 // 1 minute
  },

  // this is the default configuration for the availability
  geometry: {
    url:    null,
    bg:     null,
    parser: null // or function
  },

  minimap: {
    show: false,
    showAtScaleGreaterThan: 1
  },

  system: {
    showSeats:        true,
    showAllSeats:     false,
    scrollToZoom:     false,
    hideNavigation:   false,
    avoidSingleSeats: false
  },

  tooltip: {
    views:  null,
    parser: null // or function
  }
};



// WEBPACK FOOTER //
// ./frontend/react/sim/core/config.js